import React from "react";

function Sidebar(props) {
  return (
    <div
      className={
        props.showSidebar
          ? "flex fixed h-[100vh]  md:hidden inset-y-0 left-0 w-full bg-[#0000008c] transform -translate-x-full  md:relative  transition duration-200 ease-in-out"
          : "transform -translate-x-0 duration-200 ease-in-out transition  fixed h-[100vh] inset-y-0 left-0 w-full bg-[#0000008c] block md:hidden z-50"
      }
    >
      <div className="sidebar bg-[#B6C0E8] w-3/4 space-y-6 py-7 px-6 h-full ">
        <nav
          onClick={props.handleShowSidebar}
          className="flex flex-col space-y-6 "
        >
          <a
            className="text-[14px] text-white"
            href="/"
            onClick={(e) => {
              props.handleShowSidebar;
              let hero = document.getElementById("about");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("about", "about", "/about");
            }}
          >
            About
          </a>
          <a
            className="text-[14px] text-white"
            href="/"
            onClick={(e) => {
              props.handleShowSidebar;
              let hero = document.getElementById("roadmap");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("roadmap", "roadmap", "/roadmap");
            }}
          >
            Roadmap
          </a>
          <a
            className="text-[14px] text-[#fff]"
            href="/"
            onClick={(e) => {
              let hero = document.getElementById("lore");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("lore", "lore", "/lore");
            }}
          >
            Lore
          </a>
          <a
            className="text-[14px] text-white"
            href="/"
            onClick={(e) => {
              props.handleShowSidebar;
              let hero = document.getElementById("campaign");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("campaign", "campaign", "/campaign");
            }}
          >
            Give Campaign
          </a>
          <a
            className="text-[14px] text-white"
            href="/"
            onClick={(e) => {
              props.handleShowSidebar;
              let hero = document.getElementById("team");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("team", "team", "/team");
            }}
          >
            Team
          </a>

          <a
            className="text-[14px] text-white"
            href="/"
            onClick={(e) => {
              props.handleShowSidebar;
              let hero = document.getElementById("faq");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("faq", "faq", "/faq");
            }}
          >
            FAQ
          </a>
        </nav>
        <div
          className="h-full absolute right-0 top-0"
          onClick={props.handleShowSidebar}
        >
          <p
            className="text-[30px] text-white font-black px-5"
            onClick={props.handleShowSidebar}
          >
            x
          </p>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
